import React, { useState } from "react";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import {
  LayoutDashboard,
  User,
  FileText,
  History,
  Menu,
  ChevronDown,
  ChevronRight,
  Power,
  Plane,
  Building2,
  Clock ,
  Barcode
} from "lucide-react";
import "./AppLayout.css";

// ✅ IMPORT LOGOS
import BrandLogo from "../assets/Logo Patra Travels (half white logo).png"; 
import IconLogo from "../assets/icon logo.png"; 

const AppLayout = () => {
  const navigate = useNavigate();
  const location = useLocation();
  
  // State Management
  const [collapsed, setCollapsed] = useState(false);
  const [openModule, setOpenModule] = useState("Driver Module"); // Default open module
  const [openMenu, setOpenMenu] = useState(null); // Default open sub-menu

  const [currentTime, setCurrentTime] = React.useState("");

React.useEffect(() => {
  const updateTime = () => {
    const now = new Date();
    setCurrentTime(
      now.toLocaleTimeString("en-IN", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      })
    );
  };

  updateTime(); // initial
  const timer = setInterval(updateTime, 60000); // update every minute
  return () => clearInterval(timer);
}, []);


  // ✅ 1. Define Modules & Items
  const navModules = [
    {
          module: "Agent Module",
          items: [
            { label: "Agent Feedback", path: "/feedback/agent-wise", icon: Barcode },
            { label: "Agent Booking Wise Comments", path: "/comment/agent-wise", icon: Barcode },
            { label: "Agent Leads", path: "/leads/agent-wise", icon: Barcode },
          ]
        },
    {
      module: "Driver Module",
      items: [
        { 
          label: "Master", 
          icon: History, 
          children: [
            { label: "Vehicle Checklist", path: "/master/confirmation-checklist" },
            { label: "Salary Components", path: "/master/salary-ddt-checklist" },
            { label: "Feedback Category", path: "/master/feedback-categorylist" },
            { label: "Feedback Sub-Category", path: "/master/feedback-subcategory" },
          ] 
        },
        { 
          label: "Driver Attendance", 
          icon: History, 
          children: [
            { label: "Daily Attendance", path: "/driverAttendance/daily" },
            { label: "Monthly Attendance", path: "/driverAttendance/monthly" },
          ] 
        },
        { 
          label: "Salary Process", 
          icon: User, 
          children: [
            { label: "Driver Salary", path: "/salary/driver-salary" },
             { label: "Prepare Salary", path: "/salary/prepare" },
            { label: "Confirm Salary", path: "/salary/confirm-salary" },
            { label: "Salary Slip", path: "/salary/salary-slip" },
          ] 
        },
        { label: "Drivers Activity", path: "/driver-login-status", icon: FileText },
        { label: "SOS Reports", path: "/sos", icon: FileText },
        { label: "Driver Tracking", path: "/driver-tracking", icon: Plane },
         
      ]
    },
        {
          module: "Customer Module",
          items: [
            { label: "Customer Feedback", path: "/customer/feedbacks", icon: Barcode },
          ]
        },
        // {
        //   module: "Hotel Module",
        //   items: [
        //     { label: "Hotel Inventory", path: "/hotels/inventory", icon: Building2 },
        //     { label: "Hotel Bookings", path: "/hotels/bookings", icon: Building2 },
        //   ]
        // },

    // BLOG MODULE
  {
    module: "Blogs Module",
    items: [
      { label: "Blog Page", path: "/page/blog-page-manage", icon: FileText },
      {
        label: "Category",
        icon: FileText,
        children: [
          { label: "Add Category", path: "/category/add-category" },
          { label: "Manage Category", path: "/category/manage-category" },
        ]
      },
      {
        label: "Tags",
        icon: FileText,
        children: [
          { label: "Add Tags", path: "/tags/add-tags" },
          { label: "Manage Tags", path: "/tags/manage-tags" },
        ]
      },
       {
        label: "Blogs",
        icon: FileText,
        children: [
          { label: "Add Blog", path: "/add-blog" },
          { label: "Manage Blogs", path: "/blog-manage" },
        ]
      }
       
    ]
  },
  {
    module: "Visa  Module",
    items: [
       {
              label: "Visa Assistance",
              icon: FileText,
              children: [
                 { label: "Landing page", path: "/page/visa-assistance-page-manage", icon: FileText },
                { label: "Manage Country", path: "/country/manage-country" },
                 { label: "Manage tab", path: "/tab/manage-tab" },
                { label: "Manage Visa Assistance", path: "/visa-assistance-manage" },
              ]
            },
            {
              label: "City Name Master",
              icon: FileText,
              children: [
                { label: "Manage City Name", path: "/city/manage-city-name" },
                 { label: "Manage Country City Name", path: "/country-city/manage-country-city-name" },
              ]
            }
       
      
      
       
    ]
  },
  {
    module: "Holidays  Module",
    items: [
        {
              label: "Packages Master",
              icon: FileText,
              children: [
                { label: "Packages Manage", path: "/holidays/packages/manage-packages" },
                { label: "Country Manage", path: "/holidays/country/manage-country" },
                { label: "State Manage", path: "/holidays/state/manage-state" },
                { label: "City Manage", path: "/holidays/city/manage-city" },
                { label: "Navigation Tabs Manage", path: "/holidays/tabs/manage-tabs" },
                { label: "Duration Manage", path: "/holidays/duration/manage-duration" },
                { label: "Services Included Manage", path: "/holidays/services-included/manage-services-included" },
                // { label: "City/Destination Manage ", path: "/holidays/city/manage-city" },
              ]
            },
            {
              label: "Holidays",
              icon: FileText,
              children: [
                { label: "Holiday Packages Page", path: "/holidays/holiday-packages-home-page", icon: FileText },
                { label: "Manage Holiday Packages", path: "/holidays/holiday-packages-manage" },
              ]
            }
          
       
      
      
       
    ]
  }
  // {
  //   module: "Contact Us",
  //   items: [
  //     { label: "Manage Contact Us", path: "/page/manage-contact", icon: FileText },
     
       
  //   ]
  // }
  ];

  const isActive = (path) => location.pathname === path || location.pathname.startsWith(path + "/");

  const handleLogout = () => {
    localStorage.clear();
    window.location.href = "https://www.patratravels.com/admin/home.php";
  };

  // Toggle Top-Level Module (Driver, Flight, etc.)
  const toggleModule = (moduleName) => {
    if (collapsed) {
      setCollapsed(false);
      setOpenModule(moduleName);
    } else {
      setOpenModule(openModule === moduleName ? null : moduleName);
    }
  };

  // Toggle Inner Sub-menu (Master, Salary Process)
  // ✅ CORRECTED LOGIC: Handles expansion when collapsed
  const toggleSubmenu = (e, label, moduleName) => {
    e.stopPropagation(); // Prevent conflicts with parent clicks

    if (collapsed) {
      // If sidebar is collapsed, we must perform 3 steps:
      setCollapsed(false);       // 1. Open the sidebar
      setOpenModule(moduleName); // 2. Open the correct Module (e.g., Driver)
      setOpenMenu(label);        // 3. Open the specific Sub-menu (e.g., Master)
    } else {
      // Normal behavior: just toggle the sub-menu
      setOpenMenu(openMenu === label ? null : label);
    }
  };

  return (
    <div className={`al-layout-container ${collapsed ? "al-collapsed" : ""}`}>
      {/* ================= SIDEBAR ================= */}
      <aside className="al-sidebar">
        
        {/* LOGO HEADER */}
        <div className="al-sidebar-header">
          <div className="al-logo-container">
            {collapsed ? (
               <img src={IconLogo} alt="P" className="al-logo-icon-img" />
            ) : (
               <img src={BrandLogo} alt="Patra Travels" className="al-logo-full-img" />
            )}
          </div>
        </div>

        {/* NAVIGATION CONTENT */}
        <div className="al-sidebar-content">
          <nav className="al-nav-menu">
            
            {/* 1. Global Dashboard Link (Always Visible) */}
            <div 
              className={`al-nav-item ${isActive("/dashboard") ? "al-active" : ""}`}
              onClick={() => navigate("/dashboard")}
            >
              <LayoutDashboard size={20} className="al-nav-icon" />
              <span className="al-nav-label">Dashboard</span>
            </div>

            {/* 2. Loop Through Modules */}
            {navModules.map((group) => {
              const isModuleOpen = openModule === group.module;
              
              return (
                <div key={group.module} className={`al-module-wrapper ${isModuleOpen ? "al-module-open" : ""}`}>
                  
                  {/* Module Header (Clickable) */}
                  <div className="al-module-header" onClick={() => toggleModule(group.module)}>
                    <span className="al-module-title">{group.module}</span>
                    <div className="al-module-arrow">
                      {isModuleOpen ? <ChevronDown size={14} /> : <ChevronRight size={14} />}
                    </div>
                  </div>

                  {/* Module Items Container (Animated) */}
                  <div className="al-module-items-container">
                    {group.items.map((item) => {
                      const Icon = item.icon;
                      const hasChildren = !!item.children;
                      const isSubOpen = openMenu === item.label;
                      const isItemActive = isActive(item.path);

                      return (
                        <div key={item.label} className="al-nav-group-item">
                          
                          {/* Main Nav Item */}
                          <div
                            className={`al-nav-item ${isItemActive ? "al-active" : ""} ${isSubOpen ? "al-sub-open" : ""}`}
                            onClick={(e) => 
                              hasChildren 
                                // ✅ FIXED: Passing group.module here ensures correct expansion
                                ? toggleSubmenu(e, item.label, group.module) 
                                : navigate(item.path)
                            }
                          >
                            <Icon size={20} className="al-nav-icon" />
                            <span className="al-nav-label">{item.label}</span>
                            
                            {hasChildren && (
                              <div className="al-arrow-wrapper">
                                {isSubOpen ? <ChevronDown size={16} /> : <ChevronRight size={16} />}
                              </div>
                            )}
                          </div>

                          {/* Sub-Menu (Nested Children) */}
                          {hasChildren && (
                            <div className={`al-submenu ${isSubOpen ? "al-expanded" : ""}`}>
                              {item.children.map((sub) => (
                                <div
                                  key={sub.path}
                                  className={`al-submenu-item ${isActive(sub.path) ? "al-sub-active" : ""}`}
                                  onClick={() => navigate(sub.path)}
                                >
                                  <span className="al-dot"></span>
                                  <span>{sub.label}</span>
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                      );
                    })}
                  </div>
                </div>
              );
            })}
          </nav>
        </div>
      </aside>

      {/* ================= MAIN CONTENT ================= */}
      <div className="al-main-wrapper">
        
        {/* TOP HEADER */}
        <header className="al-topbar d-flex justify-content-between align-items-center px-3">

            {/* LEFT */}
            <div className="al-topbar-left d-flex align-items-center gap-2">
              <button className="al-toggle-btn" onClick={() => setCollapsed(!collapsed)}>
                <Menu size={22} />
              </button>

              {collapsed && (
                <img src={BrandLogo} alt="Patra" className="al-header-logo-img" />
              )}
            </div>

            {/* RIGHT */}
            <div className="al-topbar-right d-flex align-items-center gap-3">

              <div className="d-flex align-items-center gap-2 px-3 py-2 rounded-4 shadow-sm">
                
                <div className="text-center">
                  <small className="text-white fw-bold d-block" style={{ fontSize: "12px" }}>
                    CURRENT TIME
                  </small>
                  <span className="fw-bolder text-white">{currentTime}</span>
                </div>
              </div>

              {/* Divider */}
              <div className="al-divider-vertical"></div>

              {/* LOGOUT */}
              <button
                className="al-header-logout-btn"
                onClick={handleLogout}
                title="Logout"
              >
                <Power size={20} />
              </button>

            </div>
          </header>


        {/* PAGE CONTENT */}
        <main className="al-page-content">
          <div className="al-content-container">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
};

export default AppLayout;